import { useNavigate, useParams } from "react-router-dom";
import FormCreator from "../../../components/forms/FormCreator";
import SwalAlert from "../../../services/swalService/SwalService";
import { useEffect, useRef } from "react";
import { useAddEditEmailTemplateMutation, useLazyGetAllProjectTypeDropdownQuery, useLazyGetEmailTemplateByIdQuery } from "../../../app/services/FieldManagement/EmailTemplateManagement/EmailTemplateManagementApi";
import Buttons from "../../../components/ui/button/Buttons";
import DataLoader from "../../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { setAllDropDownFieldsBatch } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { EditEmailTempData } from "./dataFile/EmailManagementDataConfig";
import { getAuditContext } from "../../../lib/authenticationLibrary";

const EditEmailTemp = () => {
    const EditEmailTempRef = useRef();
    const navigate = useNavigate();
    const { id } = useParams()
    const { success, error } = SwalAlert();
    const audit = getAuditContext();
    const [getEmailTemplateByid, { isSuccess: isSuccessEmailById, isFetching: isFetchingEmailById, data: emailtemplateByIdResponse }] = useLazyGetEmailTemplateByIdQuery();
    const [getAllProjectTypeDropdown, { isSuccess: isSuccessDropdown, isFetching: isFetchingDropdown, data: dropdownResponse }] = useLazyGetAllProjectTypeDropdownQuery()
    const [addEditEmailTemplate, { isSuccess: isSuccessAddEditEmail, isFetching: isFetchingAddEditEmail, data: addEditEmailResponse }] = useAddEditEmailTemplateMutation()

    console.log(emailtemplateByIdResponse)
    useEffect(() => {
        if (!isFetchingAddEditEmail && isSuccessAddEditEmail && addEditEmailResponse) {
            if (addEditEmailResponse.hasError === false) {
                success("Email update Successfully")
            }
            else {
                error(addEditEmailResponse.errorMessage)
            }
        }
    }, [isFetchingAddEditEmail, isSuccessAddEditEmail, addEditEmailResponse]);

    useEffect(() => {
        if (id) {
            getEmailTemplateByid(id);
        }
        getAllProjectTypeDropdown();
    }, [id])

    useEffect(() => {
        if (!isFetchingDropdown && isSuccessDropdown && dropdownResponse) {
            const field = EditEmailTempData.section[0].rowGroup[0].fields.find(field => field.id === "project");
            field.fieldSetting.options = dropdownResponse.map(obj => ({ value: obj.id, label: obj.name }));
            setAllDropDownFieldsBatch(EditEmailTempData, dropdownResponse);
        }
    }, [isFetchingDropdown, isSuccessDropdown, dropdownResponse]);

    useEffect(() => {
        if (!isFetchingEmailById && isSuccessEmailById && emailtemplateByIdResponse) {
            let tempInit = EditEmailTempData.initialState;
            tempInit.projectType = emailtemplateByIdResponse.projectTypeId;
            tempInit.subject = emailtemplateByIdResponse.subject;
            tempInit.emailName = emailtemplateByIdResponse.emailName;
            tempInit.description = emailtemplateByIdResponse.description;
            tempInit.WhereUsed = emailtemplateByIdResponse.whereUsed;
        }
    }, [isFetchingEmailById, isSuccessEmailById, emailtemplateByIdResponse]);

    const handleaUpdate = () => {
        const formData = EditEmailTempRef.current.getFormData();
        const request = {
            emailTemplateId: emailtemplateByIdResponse?.emailTemplateId || 0,
            EmailName: formData?.emailName,
            Subject: formData?.subject,
            WhereUsed: formData?.WhereUsed,
            ProjectTypeId: formData?.projectType?.value ? formData?.projectType?.value : formData?.projectType,
            Description: formData?.description,
            CreatedBy: audit.adminUserId,
            CreatedAppId: audit.appId
        }
        addEditEmailTemplate(request)
    }
    const handleBack = () => { navigate('/emailTemplateManagement') }

    const isDataReady = dropdownResponse && emailtemplateByIdResponse && !isFetchingEmailById && String(emailtemplateByIdResponse?.emailTemplateId) === String(id);
    
    return (
        <>
            {isDataReady ?
                <div className='d-flex flex-wrap email-template-form'>
                    <div className='row'>
                        <FormCreator
                            ref={EditEmailTempRef}
                            config={EditEmailTempData}
                        >
                        </FormCreator>
                    </div>

                </div>
                :
                <DataLoader />
            }

            <div className='d-flex justify-content-between'>
                <div>
                    <Buttons
                        buttonText="Back"
                        buttonTypeClassName="theme-btn"
                        onClick={() => handleBack()}
                    />
                </div>
                <div>
                    <Buttons
                        buttonText="Update"
                        buttonTypeClassName="theme-btn"
                        onClick={() => handleaUpdate()}
                    />
                </div>
            </div>
        </>
    )
}
export default EditEmailTemp;